export * from './hochladen-post-request.interface';
export * from './hochladen-post-response.interface';
export * from './hochladen-post.shapes';
